import {
  Input,
  Select,
  Box,
  FormField,
  SpaceBetween,
  Form,
  Container,
  ColumnLayout,
  Header,
  Badge,
} from "@cloudscape-design/components-themed";
import { LABELS, PULLDOWN_LABELS_SP } from "./constants";
import { COMMON_LABELS } from "../default-constants";
import { formatYearDate } from "../../utils/format";

/*===================================================================================
 * 料率調整案件の調整内容入力フォーム
 * 概要：調整内容入力フォームを実装
 *
 * 前の画面からの必要なパラメーター
 * 料率調整No
 *
 * 遷移先：なし
 * 戻り先：なし
 ===================================================================================*/
//未実装：ドロップダウン、各入力チェック

export const MerchantForm = (props: any) => {
  return (
    <Form>
      <Container
        header={
          <ColumnLayout columns={2}>
            <Box float="left">
              <Header variant="h2">
                {props.isRegister ? LABELS.TITLE_REGIST : LABELS.TITLE_EDIT}
              </Header>
            </Box>
            {!props.isRegister ? (
              <Box float="right">
                <Badge color="green">
                  {LABELS.LAST_UPDATED_BY}
                  {props.updatedBy}/{LABELS.LAST_UPDATED_DATE}
                  {formatYearDate(props.updatedAt)}
                </Badge>
              </Box>
            ) : (
              ""
            )}
          </ColumnLayout>
        }
      >
        <SpaceBetween size="l">
          <SpaceBetween direction="horizontal" size="l">
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.MERCHANT_NAME}</Box>
                  <Box variant="small" color="text-status-error">
                    {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                  </Box>
                </SpaceBetween>
              }
              errorText={props.merchantNameErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                name="merchantName"
                value={props.merchantName}
                onChange={(e) => {
                  props.setMerchantName(e.detail.value);
                  props.checkMerchantName(e.detail.value);
                  props.setIsFormEntered(true);
                }}
              />
            </FormField>
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">
                    {PULLDOWN_LABELS_SP.SERVICE_NAME_SHORT}
                  </Box>
                  <Box variant="small" color="text-status-error">
                    {PULLDOWN_LABELS_SP.REQUIRED_LONG}
                  </Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={props.serviceNameErrorMsg}
            >
              <Select
                selectedOption={props.serviceName}
                onChange={(e) => {
                  props.setServiceName(e.detail.selectedOption);
                  props.setIsFormEntered(true);
                  props.checkserviceName(e.detail.selectedOption);
                }}
                options={props.serviceNameList}
                selectedAriaLabel="Selected"
              />
            </FormField>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </Form>
  );
};
